var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-ber'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('Footer'),_c('el-backtop',{staticClass:"min"},[_c('div',[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("./assets//椭圆 4@2x.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }